export default __webpack_public_path__ + "static/media/no-avatar.849f159c.jpg";